import React, { ReactNode } from 'react';
import { Theme } from '@theme';
import { WithCoreProps, TranslationProps } from 'ff-shared-components-core';
import { HostAppCommunicationBridgeHelper } from '@helpers';
import { RegisterUserData, EntityDataConfirmationScreen } from '@screens';
import { StoreState, getRegisterPharmacyInputData, RegisterInputData, StepRegisterInputData } from '@store';
import { connect } from 'react-redux';

export interface UserDataScreenProps {
	onClickNext(data: StepRegisterInputData): void;
	onClickBack(data: any): void;
	onClickCancel: () => void;
	fetchUpdateRegisterData: (registerData: StepRegisterInputData, successHandler?: () => void) => void;
}

export interface UserDataScreenState {
	userId: any;
	isCreatingUser: boolean;
	isViewingUserDetail: boolean;
	isViewingEntityData: boolean;
}

interface UserDataScreenInjectedProps extends TranslationProps {
	data: RegisterInputData;
	a: Theme;
}

type Props = UserDataScreenProps & UserDataScreenInjectedProps;

class UserDataScreen extends React.PureComponent<Props, UserDataScreenState> {
	private isFromOutsideFlow = false;

	public constructor(props: Props) {
		super(props);
		const { data } = this.props;

		const hasUsersCreated = data && data.usersData && data.usersData.length > 0 ? true : false;
		this.isFromOutsideFlow = !hasUsersCreated;

		this.state = {
			userId: '',
			isCreatingUser: !hasUsersCreated,
			isViewingEntityData: hasUsersCreated,
			isViewingUserDetail: false,
		};
	}

	// private onClickNextCreatingUser = (): void => {
	// 	this.setState({ ...this.state, isCreatingUser: false, isViewingEntityData: true, isViewingUserDetail: false });
	// 	this.isFromOutsideFlow = false;
	// 	HostAppCommunicationBridgeHelper.scrollToTop();
	// };

	private onClickNextCreatingUser = (): void => {
		const { fetchUpdateRegisterData } = this.props;
		this.setState({ isCreatingUser: false, isViewingEntityData: true, isViewingUserDetail: false });

		this.isFromOutsideFlow = false;

		const stepInputData: StepRegisterInputData = {
			stepIndex: 2,
			registerInputData: undefined,
		};
		fetchUpdateRegisterData(stepInputData);

		HostAppCommunicationBridgeHelper.scrollToTop();
	};

	private onClickBackUserData = (): void => {
		this.setState({ ...this.state, isCreatingUser: false, isViewingEntityData: true, isViewingUserDetail: false });
		HostAppCommunicationBridgeHelper.scrollToTop();
	};

	private onClickToViewUserDetail = (row?: any): void => {
		this.setState({
			...this.state,
			isCreatingUser: false,
			isViewingEntityData: false,
			isViewingUserDetail: true,
			userId: row ? row.id : '',
		});
		HostAppCommunicationBridgeHelper.scrollToTop();
	};

	private onClickCreatingUser = (): void => {
		this.setState({ ...this.state, isCreatingUser: true, isViewingEntityData: false, isViewingUserDetail: false });
		HostAppCommunicationBridgeHelper.scrollToTop();
	};

	render(): ReactNode {
		const { onClickBack, onClickNext, onClickCancel, data, fetchUpdateRegisterData } = this.props;
		const { userId, isCreatingUser, isViewingEntityData, isViewingUserDetail } = this.state;

		return (
			<>
				{isCreatingUser ? (
					<RegisterUserData
						onClickBack={this.isFromOutsideFlow ? onClickBack : this.onClickBackUserData}
						onClickNext={this.onClickNextCreatingUser}
						onClickCancel={onClickCancel}
					/>
				) : (
					''
				)}
				{isViewingEntityData ? (
					<EntityDataConfirmationScreen
						fetchUpdateRegisterData={fetchUpdateRegisterData}
						onClickBack={onClickBack}
						onClickNext={onClickNext}
						onClickCancel={onClickCancel}
						canEditUsers={true}
						onClickCreatingUser={this.onClickCreatingUser}
						onClickToViewUserDetail={this.onClickToViewUserDetail}
					/>
				) : (
					''
				)}
				{isViewingUserDetail ? (
					// <RegisterUserDataDetails onClickBack={this.onClickBackUserData} userId={userId} />
					<RegisterUserData
						isEditMode
						onClickBack={this.onClickBackUserData}
						onClickNext={this.onClickNextCreatingUser}
						userData={data.usersData && data.usersData.find(x => x.id === userId)}
					/>
				) : (
					''
				)}
			</>
		);
	}
}

const mapStateToProps = (state: StoreState): object => ({ data: getRegisterPharmacyInputData(state) });
// const mapDispatchToProps = (dispatch: any): object => bindActionCreators({}, dispatch);

export default WithCoreProps<UserDataScreenProps>(connect(mapStateToProps, undefined)(UserDataScreen));
